import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <main className="rini-container flex min-h-[65vh] flex-col items-center justify-center text-center">
      <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#70845b]">
        404
      </p>

      <h1 className="rini-heading mt-4 text-5xl font-semibold">
        Page not found
      </h1>

      <p className="mt-4 text-[#746d65]">
        The page you are looking for does not exist.
      </p>

      <Link
        to="/"
        className="rini-button-primary mt-8"
      >
        Return home
      </Link>
    </main>
  );
}
